module.exports = __webpack_public_path__ + "img/1200.a5ef339a.jpg";